import React from "react";

import type { ExecutiveCompanyOption } from "../../types/ExecutiveCompanyOption.type";

interface CompanyResultRowProps {
	company: ExecutiveCompanyOption;
	onClick: (company: ExecutiveCompanyOption) => void;
}

const PROFILE_TYPE_LABELS: Record<string, string> = {
	CLIENT: "Client",
	SUPPLIER: "Supplier",
};

export const CompanyResultRow: React.FC<CompanyResultRowProps> = ({
	company,
	onClick,
}) => {
	const handleClick = () => {
		onClick(company);
	};

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			onClick(company);
		}
	};

	return (
		<div
			role="button"
			tabIndex={0}
			onClick={handleClick}
			onKeyDown={handleKeyDown}
			className="flex cursor-pointer items-center justify-between rounded-md px-3 py-3 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
			data-testid={`company-result-${company.id}`}
		>
			<div className="min-w-0 flex-1">
				<p className="truncate font-semibold text-gray-900">{company.name}</p>
				{company.abn && (
					<p className="mt-0.5 truncate text-sm text-gray-500">
						ABN: {company.abn}
					</p>
				)}
			</div>
			{company.profile_type && (
				<span
					className={`ml-3 inline-flex shrink-0 items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
						company.profile_type === "CLIENT"
							? "bg-blue-100 text-blue-800"
							: "bg-green-100 text-green-800"
					}`}
				>
					{PROFILE_TYPE_LABELS[company.profile_type] ?? company.profile_type}
				</span>
			)}
		</div>
	);
};
